import { createRouter, createWebHistory } from 'vue-router'

// Static page routes (mirror sparkplay.in URL style: /about-us, /contact, etc)
// One route per slug instead of `/:slug`+beforeEnter — vue-router 4 aborts the whole
// navigation when beforeEnter returns false instead of falling through to the next route.
const staticRoutes = [
  'about-us',
  'contact',
  'privacy-policy',
  'terms-of-use',
  'refund-policy',
  'copyright-policy',
  'grievance-redressal',
  'content-moderation',
  'age-rating',
  'accessibility',
  'help-center',
  'faq',
  'device-support'
].map((slug) => ({
  path: '/' + slug,
  name: 'static:' + slug,
  component: () => import('../pages/StaticPage.vue'),
  meta: { slug }
}))

const routes = [
  { path: '/', name: 'home', component: () => import('../pages/HomePage.vue') },
  // 站点只放短剧：老片库入口保留 301 语义，统一落到短剧列表
  { path: '/movies', redirect: '/dramas' },
  { path: '/dramas', name: 'dramas', component: () => import('../pages/DramaListPage.vue') },
  { path: '/dramas/:id', name: 'drama-detail', component: () => import('../pages/DramaDetailPage.vue') },
  { path: '/contents/:id', name: 'content-detail', component: () => import('../pages/ContentDetailPage.vue') },
  { path: '/login', name: 'login', component: () => import('../pages/LoginPage.vue') },
  { path: '/register', name: 'register', component: () => import('../pages/RegisterPage.vue') },
  { path: '/forgot-password', name: 'forgot-password', component: () => import('../pages/ForgotPasswordPage.vue') },
  { path: '/dashboard', name: 'dashboard', component: () => import('../pages/DashboardPage.vue') },
  { path: '/account', redirect: '/dashboard' },
  { path: '/pricing', name: 'pricing', component: () => import('../pages/PricingPage.vue') },
  // 订阅已下线：老的 /subscribe 入口统一落到票价页
  { path: '/subscribe', redirect: '/pricing' },
  { path: '/payment/:mchOrderNo', redirect: '/pricing' },
  { path: '/policies', name: 'policies', component: () => import('../pages/PoliciesPage.vue') },
  ...staticRoutes,
  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('../pages/NotFoundPage.vue') }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// Route guard: 需要登录的页面（订阅/支付页已下线）
const authedRouteNames = new Set(['dashboard'])
router.beforeEach((to) => {
  if (!authedRouteNames.has(to.name)) return true
  const token = localStorage.getItem('playtv.token')
  if (token) return true
  return { path: '/login', query: { redirect: to.fullPath } }
})

export default router